<template>
  <div>
    <el-card>
      <el-tabs v-model="activeTab" @tab-click="handleClick">
        <el-tab-pane label="工作任务制定" name="first"> </el-tab-pane>
        <el-tab-pane label="工作任务查询" name="second"> </el-tab-pane>
        <el-tab-pane label="小结记录" name="third"> </el-tab-pane>
        <div class="btn-group">
          <div class="left">
            <DepartmentSelect
              class="department-select"
              v-if="showableComp.departmentSelect"
              :disabled="disableComp.departmentSelect"
            ></DepartmentSelect>
            <div class="rowpart" v-else>
              <!-- 科室 -->
              <el-input
                v-model="behaviorForm.departmentName"
                :disabled="true"
              ></el-input>
            </div>
            <!-- 年份选择 -->
            <div class="rowpart">
              <el-date-picker
                style="width: 120px"
                v-model="behaviorForm.year"
                type="year"
                placeholder="选择年"
                format="YYYY"
                value-format="YYYY"
              >
              </el-date-picker>
            </div>

            <!-- 季度选择 -->
            <SeasonSelect
              class="rowpart"
              @season="this.behaviorForm.season = $event"
              v-model="this.behaviorForm.season"
            ></SeasonSelect>

            <div class="report-title" v-if="activeTab == 'first'">
              <!-- 标题 -->
              <el-input
                placeholder="请输入标题"
                v-model="behaviorForm.title"
                :disabled="disableComp.title"
              >
              </el-input>
            </div>
          </div>

          <div class="right" v-if="activeTab == 'third'">
            <!-- 添加周记 -->
            <el-button type="primary" @click="addWeekSummary"
              >添加周记</el-button
            >
          </div>
        </div>
        <!-- tab1内容 -->
        <el-collapse v-model="activeCollapse" v-if="activeTab == 'first'">
          <el-collapse-item title="本季工作完成情况" name="1">
            <!-- 表格 -->
            <div class="part-group">
              <div class="text">
                <span
                  >合计：共{{ behaviorForm.taskNum }}项任务，已完成{{
                    behaviorForm.taskCompleteNum
                  }}项，未完成{{ behaviorForm.taskInCompleteNum }}项</span
                >
              </div>
              <div>
                <el-button type="primary" @click="exportBehavior"
                  >导出</el-button
                >
                <el-button type="primary" @click="showAddTaskForm"
                  >添加任务</el-button
                >
                <el-button type="primary" @click="doEditHandler"
                  >编辑</el-button
                >
                <el-button type="primary" @click="deleteTask">删除</el-button>
              </div>
            </div>
            <el-table
              :data="behaviorForm.taskList"
              border
              style="width: 100%"
              height="600"
              ref="multipleTable"
              @select="handleSelect"
              @select-all="handleSelectAll"
              :default-sort="{ prop: 'taskId' }"
            >
              <el-table-column type="selection" width="55" fixed />
              <template v-for="column in TaskPlanTable" :key="column.label">
                <el-table-column
                  :prop="column.prop"
                  :label="column.label"
                  :formatter="formatter"
                  width="180"
                  sortable
                >
                </el-table-column>
              </template>
              <el-table-column label="操作" width="200" fixed="right">
                <template #default="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="handleRecord(scope.$index, scope.row)"
                    >纪实</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
          <el-collapse-item title="本季工作完成情况概述" name="2">
            <p class="sub-title">需统筹协调或其他科室配合事项</p>
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="behaviorForm.remarks"
            >
            </el-input>
            <p class="sub-title">本季工作小结</p>
            <el-input
              type="textarea"
              :rows="4"
              placeholder="请输入内容"
              v-model="behaviorForm.summary"
            >
            </el-input>

            <p class="sub-title">附件上传</p>
            <div class="upload">
              <el-upload
                ref="uploadAppendix"
                :auto-upload="false"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :file-list="behaviorForm.appendixList"
                :data="uploadAppendData"
                :http-request="uploadFile"
                :on-change="getUploadFile"
                show-file-list
                accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
              >
                <el-button size="small" type="primary">点击上传附件</el-button>
              </el-upload>
            </div>
          </el-collapse-item>
        </el-collapse>

        <div class="botton-btn" v-if="activeTab == 'first'">
          <el-button type="primary" @click="saveBehavior">保存</el-button>
          <el-button
            type="primary"
            @click="submitBehavior"
            :disabled="disableComp.submitBtn"
            >确认提交</el-button
          >
        </div>

        <!-- tab2内容 -->
        <el-table
          :data="behaviorList"
          border
          style="width: 100%"
          height="600"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :default-sort="{ prop: 'taskId' }"
          v-if="activeTab == 'second'"
        >
          <el-table-column type="selection" width="55" fixed />
          <template v-for="column in TaskPlanHistoryTable" :key="column.label">
            <el-table-column
              :prop="column.prop"
              :label="column.label"
              width="180"
              sortable
            >
            </el-table-column>
          </template>
          <el-table-column label="操作" width="200" fixed="right">
            <template #default="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleOpen(scope.$index, scope.row)"
                >查看</el-button
              >
              <el-button
                size="mini"
                type="text"
                @click="handleBack(scope.$index, scope.row)"
                >撤回</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- tab3内容 -->
        <div v-if="activeTab == 'third'">
          <el-timeline class="time-line">
            <el-timeline-item
              placement="top"
              v-for="(activity, index) in weekSummaryList"
              :key="index"
              :timestamp="activity.timestamp"
            >
              <el-card class="sum-card">
                <el-input
                  :rows="3"
                  type="textarea"
                  v-model="activity.summary"
                ></el-input>

                <div class="right-btn">
                  <el-button type="text" @click="saveSummary(index, activity)"
                    >保存</el-button
                  >
                  <el-popconfirm
                    title="确认删除?"
                    @confirm="deleteSummary(index, activity)"
                    confirm-button-text="是"
                    cancel-button-text="否"
                  >
                    <template #reference>
                      <el-button type="text">删除</el-button>
                    </template>
                  </el-popconfirm>
                </div>
              </el-card>
            </el-timeline-item>
          </el-timeline>
          <!-- <template v-for="(activity, index) in weekSummaryList" :key="index">
            <el-timeline>
              <el-timeline-item :timestamp="weekSummaryList.timestamp">
                {{ activity.content }}
              </el-timeline-item>
            </el-timeline>
          </template> -->
        </div>
      </el-tabs>
      <!-- 模态框 -->
      <el-dialog
        v-model="showableComp.addTaskDialog"
        title="任务分类"
        width="40%"
      >
        <el-collapse v-model="activeCollapse2">
          <el-collapse-item title="本季工作完成情况" name="1">
            <!-- 添加任务表单 -->
            <el-form label-width="120px" :disabled="disableComp.taskForm1">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="任务分类">
                    <el-input v-model="TaskForm.taskCategory"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="责任人">
                    <!-- <el-input v-model="TaskForm.respPerson"></el-input> -->
                    <EmployeeSelect
                      disabled
                      v-model="TaskForm.respPerson"
                      :depIdArr="[this.behaviorForm.departmentId]"
                    ></EmployeeSelect>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="工作内容">
                    <el-input
                      type="textarea"
                      v-model="TaskForm.detail"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="标准要求">
                    <el-input
                      type="textarea"
                      v-model="TaskForm.criterion"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row gutter="30">
                <el-col :span="12">
                  <el-form-item label="要求完成时限">
                    <el-date-picker
                      v-model="TaskForm.dateLimit"
                      type="date"
                      placeholder="选择日期"
                      :locale="zhCn"
                      style="width: 100%"
                      value-format="YYYY-MM-DD"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="任务类型">
                    <TaskTypeSelect
                      @taskType="TaskForm.taskType = $event"
                      v-model="TaskForm.taskType"
                    ></TaskTypeSelect>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row gutter="30">
                <el-col>
                  <el-form-item label="分值">
                    <el-input v-model="TaskForm.score"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      type="textarea"
                      v-model="TaskForm.remarks"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
          <el-collapse-item
            title="本季工作完成情况"
            name="2"
            v-if="showableComp.taskForm2 == true"
          >
            <!-- 纪实表单 -->
            <el-form label-width="120px">
              <el-row>
                <el-col :span="12">
                  <el-form-item label="是否完成">
                    <AvailableSelect
                      @available="TaskForm.accomplish = $event"
                      v-model="TaskForm.accomplish"
                    ></AvailableSelect>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="完成时间">
                    <el-date-picker
                      v-model="TaskForm.accomplishDate"
                      type="date"
                      placeholder="选择日期"
                      :locale="zhCn"
                      style="width: 200px"
                      value-format="YYYY-MM-DD"
                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item label="完成时效">
                    <el-input v-model="TaskForm.accomplishTimeRatio"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="完成比例"
                    ><el-input v-model="TaskForm.accomplishRatio"></el-input
                  ></el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <el-form-item label="完成情况"
                    ><el-input
                      type="textarea"
                      v-model="TaskForm.accomplishDetail"
                    ></el-input
                  ></el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
        <div class="botton-btn">
          <el-button
            type="primary"
            @click="saveRecord"
            v-if="showableComp.btn1 == true"
            >保存</el-button
          >
          <el-button
            v-if="showableComp.btn2 == true"
            type="primary"
            @click="addTask"
            >确认添加</el-button
          >
          <el-button type="default" @click="doCancelAddTask">取消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
// DepTaskMake
import PersonalTaskMake from "../api/PersonalTaskMake";
export default PersonalTaskMake;
</script>

<style scoped lang="scss">
.btn-group {
  display: flex;
  justify-content: space-between;
}
.left {
  display: flex;
  justify-content: start;
  margin-bottom: 20px;
}

.rowpart {
  margin-right: 10px;
  width: 120px;
}

.width-120 {
  width: 120px;
}

.el-date-picker {
  width: 120px;
}

.report-title {
  width: 360px;
}

.department-select {
  margin-right: 10px;
  width: 200px;
}

.el-card {
  margin-bottom: 60px;
}

.botton-btn {
  margin-top: 10px;
  display: flex;
  justify-content: end;
}

.part-group {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}

.text {
  display: flex;
  align-items: center;
}

.sub-title {
  text-align: left;
}
.upload {
  text-align: left;
  width: 60%;
}

.time-line {
  text-align: left;
}

.sum-card {
  margin-bottom: 10px;
}

.right-btn {
  display: flex;
  justify-content: end;
}
</style>